var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row d-flex justify-content-center"},[_c('div',{staticClass:"col-12"},[_c('ContactForm',{attrs:{"title":_vm.$t('contact:form.first_text'),"sub-title":_vm.$t('contact:form.second_text')}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }